"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCOSCSettingsT = exports.VRCOSCSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const oscsettings_js_1 = require("../../solarxr-protocol/rpc/oscsettings.js");
const osctrackers_setting_js_1 = require("../../solarxr-protocol/rpc/osctrackers-setting.js");
/**
 * OSC Settings specific to VRChat
 */
class VRCOSCSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsVRCOSCSettings(bb, obj) {
        return (obj || new VRCOSCSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsVRCOSCSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new VRCOSCSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    oscSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new oscsettings_js_1.OSCSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    trackers(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new osctrackers_setting_js_1.OSCTrackersSetting()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    oscqueryEnabled() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startVRCOSCSettings(builder) {
        builder.startObject(3);
    }
    static addOscSettings(builder, oscSettingsOffset) {
        builder.addFieldOffset(0, oscSettingsOffset, 0);
    }
    static addTrackers(builder, trackersOffset) {
        builder.addFieldOffset(1, trackersOffset, 0);
    }
    static addOscqueryEnabled(builder, oscqueryEnabled) {
        builder.addFieldInt8(2, +oscqueryEnabled, +false);
    }
    static endVRCOSCSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new VRCOSCSettingsT((this.oscSettings() !== null ? this.oscSettings().unpack() : null), (this.trackers() !== null ? this.trackers().unpack() : null), this.oscqueryEnabled());
    }
    unpackTo(_o) {
        _o.oscSettings = (this.oscSettings() !== null ? this.oscSettings().unpack() : null);
        _o.trackers = (this.trackers() !== null ? this.trackers().unpack() : null);
        _o.oscqueryEnabled = this.oscqueryEnabled();
    }
}
exports.VRCOSCSettings = VRCOSCSettings;
class VRCOSCSettingsT {
    constructor(oscSettings = null, trackers = null, oscqueryEnabled = false) {
        this.oscSettings = oscSettings;
        this.trackers = trackers;
        this.oscqueryEnabled = oscqueryEnabled;
    }
    pack(builder) {
        const oscSettings = (this.oscSettings !== null ? this.oscSettings.pack(builder) : 0);
        const trackers = (this.trackers !== null ? this.trackers.pack(builder) : 0);
        VRCOSCSettings.startVRCOSCSettings(builder);
        VRCOSCSettings.addOscSettings(builder, oscSettings);
        VRCOSCSettings.addTrackers(builder, trackers);
        VRCOSCSettings.addOscqueryEnabled(builder, this.oscqueryEnabled);
        return VRCOSCSettings.endVRCOSCSettings(builder);
    }
}
exports.VRCOSCSettingsT = VRCOSCSettingsT;
